import $ from 'jquery'

const menuModalLinks = $('.menu-item')
const menuImages = $('.menu-image')

menuModalLinks.on('mouseenter', function () {
  let linkId = $(this).attr('id')
  let image = $('*[data-menu-id="' + linkId + '"]')

  menuImages.css('opacity', '0')
  if (image.length !== 0) {
    image.css('opacity', '1')
  } else {
    $(menuImages[0]).css('opacity', '1')
  }
})

const menu = document.getElementById('menu-modal')

if (menu) {
  const hamburger = document.querySelector('.hamburger')

  menu.addEventListener('show.bs.modal', () => {
    document.body.classList.add('menu-active')
    hamburger.classList.add('is-active')
  })

  menu.addEventListener('hide.bs.modal', () => {
    document.body.classList.remove('menu-active')
    hamburger.classList.remove('is-active')
  })
}
